import { Button, MenuItem, Select, Stack, Typography } from "@mui/material";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { ObjectStatus } from "../../../Core/Api/Types/object-status";
import {
  AddOrUpdateStatusHistoryFilter,
  GetStatusHistoryFilter,
  RemoveStatusHistoryFilter,
  StatusHistoryFilter,
} from "../../../Redux/Reducers/redux-slice-filters";
import { GetObjectStatusLabel } from "../../../Utils/helpers";
import FilterAccordion from "../FilterAccordion/filters-accordion";
import { DesktopDatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import GlobalConst from "../../../Core/Utils/Constants/globals";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const StatusHistoryPanelFilter: React.FC = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const statusHistoryFilter = useSelector(GetStatusHistoryFilter);
  const [expandedStatusHistory, setExpandedStatusHistory] = React.useState(false);
  const [statusHistoryLocal, setStatusHistoryLocal] = React.useState<StatusHistoryFilter>({
    status: ObjectStatus.Accepted,
  });

  const handleAddFilter = () => {
    dispatch(AddOrUpdateStatusHistoryFilter(statusHistoryLocal));
  };

  const handleRemoveFilter = (status: ObjectStatus) => {
    dispatch(RemoveStatusHistoryFilter(status));
  };
  return (
    <Stack>
      <FilterAccordion
        title={t("component:filterAccordion.title.statusHistory")}
        nbActiveFilters={statusHistoryFilter.length}
        expanded={expandedStatusHistory}
        onExpand={() => setExpandedStatusHistory(!expandedStatusHistory)}
      >
        {statusHistoryFilter.map((x) => (
          <Stack mb={2} height={"36px"} direction={"row"} width={"100%"} justifyContent={"space-between"}>
            <Typography lineHeight={"36px"}>{GetObjectStatusLabel(x.status)} </Typography>
            <Button onClick={() => handleRemoveFilter(x.status)}>{t("common:remove")}</Button>
          </Stack>
        ))}
        <Select
          fullWidth
          value={statusHistoryLocal.status}
          onChange={(e) => setStatusHistoryLocal((x) => ({ ...x, status: e.target.value as ObjectStatus }))}
        >
          {Object.keys(ObjectStatus)
            .filter((x) => !statusHistoryFilter.find((s) => s.status === x))
            .map((x) => (
              <MenuItem value={x}>{GetObjectStatusLabel(x as ObjectStatus)}</MenuItem>
            ))}
        </Select>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DesktopDatePicker
            label={t("common:startDate")}
            value={dayjs(statusHistoryLocal.startDate || "")}
            onChange={(newValue) => {
              setStatusHistoryLocal((x) => ({ ...x, startDate: newValue ? new Date(newValue.toString()) : undefined }));
            }}
            format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
          />
          <DesktopDatePicker
            label={t("common:endDate")}
            value={dayjs(statusHistoryLocal.endDate || "")}
            onChange={(newValue) => {
              setStatusHistoryLocal((x) => ({ ...x, endDate: newValue ? new Date(newValue.toString()) : undefined }));
            }}
            format={GlobalConst.MOMENT_DATE_FORMAT_DATENOHOURS}
          />
        </LocalizationProvider>
        <Button fullWidth onClick={handleAddFilter}>
          {t("button:addFilter")}
        </Button>
      </FilterAccordion>
    </Stack>
  );
};

export default StatusHistoryPanelFilter;
